import {
    Grid, TableContainer,
    Table,
    TableRow,
    TableHead,
    TableCell,
    TableBody, Button, TablePagination,Box
} from "@material-ui/core"
import { withStyles } from '@material-ui/core/styles'
import { format } from 'date-fns'
import { useState,useEffect } from "react"
import { TextField, Paper, useMediaQuery } from "@mui/material"
import { DataGrid } from '@mui/x-data-grid'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import styles from "./InCompleteKYCStyles"
import dayjs from 'dayjs'
import axios from "axios"
import { backendHosts,apiUrl } from "../../../../ui-utils/apiConfig"
const Lead = ({classes})=>{
   

    const textFieldStyles = {
        marginLeft: '10px !important',
        width: '150px !important',
        '& .MuiInputBase-root': {
            backgroundColor: '#131E2E !important',
            color: 'white !important',
            fontFamily: 'cardiuma-regular',
            fontSize: '15px'
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '131E2E !important',
        },
        '& .MuiInputLabel-root': {
            color: 'white !important',
            fontFamily: 'cardiuma-regular',
            fontSize: '14px',
        },
        '& .MuiInputBase-input': {
            color: 'white !important',
        },
    }

  
  const screen1800px = useMediaQuery("(max-width:1800px)")
    const [lead,setLead]=useState(null)
    const [leadTdate, setLeadTdate] = useState(null)
    const [leadFdate, setLeadFdate] = useState(null)
    const [leadRefcode,setLeadRefcode]=useState("")

    useEffect(()=>{
      handleFetchLeadsData()
    },[])

    const handleFetchLeadsData = async()=>{
        try{
            const payload = {
                data:{
                    from: "",
                    to: "",
                    referral_code: ""
                }
            }
            const response = await axios.post(`${backendHosts.ADMIN}/api/kyc/leads`, payload)
            let data = response?.data?.data?.data?.data
            console.log("Leads Data", data)
            setLead(data)

        }catch(error){
             console.log("Something went wrong while fetching lead Data",error)
        }
    }

    const handleLeadSubmit = async () => {
        try {
            const payload = {
                data: {
                    from: leadFdate || "",
                    to:leadTdate || "",
                    referral_code:leadRefcode
                }
            }
            const response = await axios.post(`${backendHosts.ADMIN}/api/kyc/leads`, payload)
            let data = response?.data?.data?.data?.data
            console.log("Leads Data", data)
            setLead(data)
        } catch (error) {
            console.log("Something went wrong while fetching lead Data", error)
        }
    }

    const handleLeadFDate = async (newValue)=>{
        setLeadFdate(dayjs(newValue).format('YYYY-MM-DD'))
    }

    const handleLeadTDate = async (newValue) => {
        setLeadTdate(dayjs(newValue).format('YYYY-MM-DD'))
    }

    const handleLeadReset = async () => {
         setLeadFdate(null)
         setLeadTdate(null)
         setLeadRefcode("")
         handleFetchLeadsData()
    }
   
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [page, setPage] = useState(0)

  const handlePageChange = (event, newpage) => {
    setPage(newpage)
  }
  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(+event.target.value)
    setPage(0)
  }


    return (
        <>
            <div style={{ height:"100vh" }}>

                <div style={{ margin: '2% 0 1% 0%' }}>
                    <form className={classes.kycFormDateField}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <span >
                                <DatePicker
                                    label="From"
                                    format="DD-MM-YYYY"
                                    variant="outlined"
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{ className: classes.input }}
                                    className={classes.datePicker}
                                    value={leadFdate}
                                    onChange={(newValue) => { handleLeadFDate(newValue) }}
                                    maxDate={dayjs()} 
                                />
                            </span>
                            <span
                                className={classes.datePickerWrapper}
                            >
                                <DatePicker
                                    label="To"
                                    format="DD-MM-YYYY"
                                    variant="outlined"
                                    InputLabelProps={{ shrink: true }}
                                    InputProps={{ className: classes.input }}
                                    className={classes.datePicker}
                                    value={leadTdate}
                                    onChange={(newValue) => { handleLeadTDate(newValue) }}
                                    maxDate={dayjs()} 
                                />
                            </span>
                            <TextField
                                label="ReferralCode"
                                variant="outlined"
                                value={leadRefcode}
                                onChange={(e) => { setLeadRefcode(e.target.value)}}
                                size='small'
                                sx={{ ...textFieldStyles }}
                            />

                            <Button
                                onClick={handleLeadSubmit}
                                style={{
                                    width: '80px',
                                    height: '40px',
                                    padding: '8px 24px',
                                    gap: '10px',
                                    color: '#000000',
                                    backgroundColor: '#F3D45E',
                                    fontFamily: 'cardiuma-regular',
                                    fontSize: '11px',
                                    fontStyle: 'normal',
                                    marginLeft:"15px"
                                }}
                            >
                                Submit
                            </Button>

                            <Button
                                onClick={handleLeadReset}
                                style={{
                                    width: '80px',
                                    height: '40px',
                                    padding: '8px 24px',
                                    marginLeft: '10px',
                                    gap: '10px',
                                    color: '#000000',
                                    backgroundColor: '#F3D45E',
                                    fontFamily: 'cardiuma-regular',
                                    fontSize: '11px',
                                    fontStyle: 'normal',
                                    marginLeft: "10px"
                                }}
                            >
                                Reset
                            </Button>
                            {/* added plans dropdown START by kartik - 10-01-2025 */}
                            {/* <Grid style={{ marginLeft: "10px", borderRadius: "5px" }}>
                        <FormControl size="small" style={{ width: "100%" }}>
                            <InputLabel className={classes.inputColor} id="demo-select-small-label">
                                Plans
                            </InputLabel>
                            <Select
                                className={classes.select}
                                labelId="demo-select-small-label"
                                id="demo-select-small"
                                value={selectPlan}
                                label="Select"
                                onChange={(newValue) => { handlePlans(newValue) }}
                                displayEmpty
                                MenuProps={{
                                    PaperProps: {
                                        style: {
                                            top: '50px'
                                        },
                                    },
                                }}
                                sx={{
                                    height: '40px',
                                    ".css-hfutr2-MuiSvgIcon-root-MuiSelect-icon": {
                                        color: "white !important"
                                    },
                                    ".css-bpeome-MuiSvgIcon-root-MuiSelect-icon":{
                                        color: "white !important"
                                    }
                                }}
                            >
                                <MenuItem className={classes.intSelText} value="Subscription">
                                    Subscription
                                </MenuItem>
                              
                                 <MenuItem className={classes.intSelText} value="Zero brokerage">
                                    Zero Brokerage
                                </MenuItem>
                                <MenuItem className={classes.intSelText} value="Zero brokerage Year">
                                    Zero Brokerage Year
                                </MenuItem>
                            </Select>
                        </FormControl>
                    </Grid> */}
                            {/* added plans dropdown END by kartik - 10-01-2025 */}
                            {/* commented the code  and added client code by dev-trupti on 24-12-2024 */}
                            {/* <span className={classes.checkBox}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={checkboxToggle === "completed"}
                                    onChange={(e) => {//dev-trupti on 26-11-2024
                                        setHide(false)
                                        handlecheckboxChange(e, "completed")}}
                                />
                            }
                            label="Completed"
                        />

                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={checkboxToggle === "incompleted"}
                                    onChange={(e) => {//dev-trupti on 26-11-2024
                                        setHide(true)
                                        setStatus(false)
                                        handlecheckboxChange(e, "incompleted")}}
                                />
                            }
                            label="Incomplete"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={checkboxToggle === "pending"}
                                    onChange={(e) => {//dev-trupti on 26-11-2024
                                        setHide(false)
                                        handlecheckboxChange(e, "pending")
                                    }}
                                />
                            }
                            label="Bank Pending"
                        />
                        {hide && <FormControlLabel
                            control={
                                <Checkbox
                                checked={status === true}
                                onChange={(e) =>{
                                    if(e.target.checked){
                                        setStatus(e.target.checked)
                                        handlecheckboxChange(e, "incompleted","INACTIVE")
                                    }else{
                                        setStatus(e.target.checked)
                                        handlecheckboxChange(e, "incompleted","ACTIVE")
                                    }}}
                                />
                            }
                            label="Archieved"
                        />}
                    </span> */}


                        </LocalizationProvider>
                    </form>
                </div>
      
            
                <Box className={classes.horizantalTablayout1}>  
                    <TableContainer >
                        <Table >
                        <TableHead>
                            <TableRow style={{ borderBottom: "2px solid Black" }}>
                                
                                    <TableCell className={`${classes.tableHeading} ${classes.tableHeadCell}`} align="left">
                                   Last_Activity
                                </TableCell>
                                    <TableCell className={`${classes.tableHeading} ${classes.tableHeadCell}`} align="left">
                                    Phone
                                </TableCell>
                                    <TableCell className={`${classes.tableHeading} ${classes.tableHeadCell}`} align="left">
                                   Refcode
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        {/* <TableBody>
                         
                            {lead?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item, index) => (
                                <TableRow
                                    key={index}
                                    style={{ borderBottom: "2px solid Black" }}
                                >
                                    
                                    <TableCell align="left" className={classes.rowText}>
                                        {format(new Date(item.updatedAt), 'yyyy-MM-dd HH:mm')}
                                    </TableCell>
                                    <TableCell align="left" className={classes.rowText}>
                                        {item.mobile}
                                    </TableCell>
                                    <TableCell align="left" className={classes.rowText}>
                                        {item.referral_code}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody> */}
                            <TableBody>
                                {lead?.length === 0 ? (
                                    <TableRow>
                                        <TableCell
                                            colSpan={3}
                                            align="center"
                                            style={{ color: "#fff", padding: "20px", fontSize: "16px",fontFamily:"cardiuma-M" }}
                                        >
                                            No rows available
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    lead
                                        ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((item, index) => (
                                            <TableRow key={index} style={{ borderBottom: "2px solid Black" }}>
                                                <TableCell align="left" className={classes.rowText}>
                                                    {format(new Date(item.updatedAt), "yyyy-MM-dd HH:mm")}
                                                </TableCell>
                                                <TableCell align="left" className={classes.rowText}>
                                                    {item.mobile}
                                                </TableCell>
                                                <TableCell align="left" className={classes.rowText}>
                                                    {item.referral_code}
                                                </TableCell>
                                            </TableRow>
                                        ))
                                )}
                            </TableBody>

                    </Table>
                    
                </TableContainer>
                <Box>
                        <TablePagination
                            className={classes.pagination}
                            rowsPerPageOptions={[10, 15, 20]}
                            component="div"
                            count={lead?.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handlePageChange}
                            onRowsPerPageChange={handleRowsPerPageChange}
                        />
                </Box>
                
                </Box>
            </div>

            
        </>
    )
}


export default withStyles(styles)(Lead)